export const getDifferenceInMinutesFromNow = endDate => {
  const now = new Date().getTime();
  endDate = new Date(endDate * 1000).getTime();
  const difference = endDate - now;
  const minutes = Math.floor(difference % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(difference % (1000 * 60) / 1000);
  const time = `${minutes}:${('0' + seconds).slice(-2)}`;
  return {
    time,
    difference
  };
};
export const formatLocalDate = (date, locale) => new Intl.DateTimeFormat(locale, {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric'
}).format(new Date(date.year(), date.monthValue() - 1, date.dayOfMonth()));